import { Injectable } from "@angular/core";
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";

@Injectable()
export class ValidatorsService {
  static _isInteger(value){
    return (parseFloat(value) == parseInt(value)) && ! isNaN(value);
  }

  public isInteger = (control:FormControl) => {
    let value = control.value;

    let isValid = ValidatorsService._isInteger(value);

    return isValid ? null : {
      validateInteger: {
        valid: false
      }
    };
  }

  public atLeastOneChecked = (formGroup: FormGroup) => {
    let isValid: boolean = false;

    if (formGroup && formGroup.controls) {
      Object.keys(formGroup.controls).map(key => {
        let fg = formGroup.controls[key] as FormControl;

        // If we come across at least one checked, it's valid
        if (fg.value) {
          isValid = true;
        }

      });
    }

    return isValid ? null : {
      validateAtLeastOneChecked: {
        valid: false
      }
    };
  }

  public validateTime(control: AbstractControl) {
    const INVALID_TIME = {validTime: true};

    let isValid: boolean = true;
    if (control && control.value) {
      let a: string[] = control.value.split(":");
      if (a.length != 2) {
        return INVALID_TIME;
      }

      if (!ValidatorsService._isInteger(a[0]) || !ValidatorsService._isInteger(a[1])) {
        return INVALID_TIME;
      }

      let hr: number = parseInt(a[0]);

      if (hr < 6 || hr > 29) {
        return INVALID_TIME;
      }

      // test min is 2 digits
      if( a[1].length != 2 ){
        return INVALID_TIME;
      }

      let min: number = parseInt(a[1]);
      if (min < 0 || min > 59) {
        return INVALID_TIME;
      }
    }

    return null;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/validators/validators.service.ts